import moment from 'moment'
import numeral from 'numeral'
import truncate from 'lodash/truncate'
import lowerCase from 'lodash/lowerCase'
import startCase from 'lodash/startCase'
import * as momentFormats from '@/plugins/moment'

export let textMore = (s, l) => truncate(s, { length: (l) || 30, separator: ' ' })
export let dateShort = (d) => moment(d).format(momentFormats.dateShortFormat)
export let dateLong = (d) => moment(d).format(momentFormats.dateLongFormat)
export let dateTimeShort = (d) => moment(d).format(momentFormats.dateTimeShortFormat)
export let dateTimeLong = (d) => moment(d).format(momentFormats.dateTimeLongFormat)
export let dateISO = (d) => moment(d).format()
export let currency = (n) => numeral(n).format('$ 0,0.00')
export let wholeNumber = (n) => parseInt(n)
export let titleCase = (s) => startCase(lowerCase(s))
